module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-18-x-18.c90802e1.svg";